export const defaultIGTF = 0.75;
export const defaultIVA = 0.16;
